import { render, staticRenderFns } from "./ResponsiveLayout.vue?vue&type=template&id=0d38aade&scoped=true&"
import script from "./ResponsiveLayout.vue?vue&type=script&lang=js&"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveLayout.vue?vue&type=style&index=0&id=0d38aade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38aade",
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QAvatar,QToolbarTitle,QIcon,QFooter,QDrawer,QScrollArea,QPageContainer,QPage,QBtn,TouchPan} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QAvatar,QToolbarTitle,QIcon,QFooter,QDrawer,QScrollArea,QPageContainer,QPage,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {TouchPan})
